import callApi from './personnelService';

const basePath = `/frontend/api/one-to-one/${process.env.VUE_APP_COMPANY_KEY}/point-collection`;

export const getMemberData = (userId) => callApi({
  method: 'POST',
  endpoint: `${basePath}/get-member-order-online-data`,
  body: userId
});

export const getMemberCountList = () => callApi({
  endpoint: `${basePath}/get-member-order-online-count`
});

export const getActivityList = () => callApi({
  endpoint: `${basePath}/get-enable-point-collection`
});

export const getMissionsList = (input) => callApi({
  method: 'POST',
  endpoint: `${basePath}/get-point-collection-mission-total`,
  body: input
});

export const getJoinMemberList = (input) => callApi({
  method: 'POST',
  endpoint: `${basePath}/get-point-collection-mission-members`,
  body: input
});

export const getMemberPointsList = (input) => callApi({
  method: 'POST',
  endpoint: `${basePath}/get-member-join-point-collection`,
  body: input
});

export const getMemberPointsStatus = (input) => callApi({
  method: 'POST',
  endpoint: `${basePath}/get-member-point-collection-complete-status`,
  body: input
});
